"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _layout = require("@berlitz/globals/lib/components/layout");
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _testimonials = _interopRequireDefault(require("@berlitz/testimonials"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SectionTestimonial = (0, _styledComponents.default)(_layout.Section).withConfig({
  displayName: "BlockTestimonialCarousel__SectionTestimonial",
  componentId: "uavdif-0"
})(["@media (max-width:", "){padding-bottom:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.md;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.layout.lg;
});
var BlockTestimonialCarousel = function BlockTestimonialCarousel(_ref3) {
  var backgroundColor = _ref3.backgroundColor,
    disablePaddingBottom = _ref3.disablePaddingBottom,
    disablePaddingTop = _ref3.disablePaddingTop,
    size = _ref3.size,
    testimonials = _ref3.testimonials,
    title = _ref3.title,
    subtitle = _ref3.subtitle,
    readMoreText = _ref3.readMoreText,
    readMoreAsLink = _ref3.readMoreAsLink;
  return /*#__PURE__*/_react.default.createElement(SectionTestimonial, {
    backgroundColor: backgroundColor,
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 10
  }, /*#__PURE__*/_react.default.createElement(_testimonials.default, {
    title: title,
    subtitle: subtitle,
    data: testimonials,
    readMoreText: readMoreText,
    readMoreAsLink: readMoreAsLink
  })))));
};
BlockTestimonialCarousel.defaultProps = {
  backgroundColor: 'ui00',
  size: 'lg',
  testimonials: []
};
var _default = BlockTestimonialCarousel;
exports.default = _default;